import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION37: PdfComponent = {
  type: 'section',
  id: 's37',
  title: '37. Language',
  content: [
    {
      type: 'altText',
      id: 's37bullets',
      content: [
        'This Agreement is drafted in the English language. If this Agreement is translated into any other language, the English language version shall prevail.',
      ],
      boldFirst: false,
    },
  ],
};
